module.exports = __webpack_public_path__ + "img/symbol_1.af28fde4.png";